<template>
  <div class="filterContent">
    <div>
      <br />
      <!-- 金额输入区 -->
      <div class="flex1 text-align-left">
        <span class="model_title">可提现余额</span>
        ￥
        <span>{{ property.usable / 100 }}</span>
        &nbsp;&nbsp;
        <a class="link" @click="withDrawAll">全部提现</a>
      </div>
      <br />
      <!-- 重新上传区 -->
      <p @click="sheetVisible = true" v-if="qrocodes.length === 2" class="uploadAgain">点击重新上传</p>
      <!-- 二维码区 -->
      <div class="flex codeContainer">
        <div class="uploadWx">
        	<p class="reload" v-if="qrocodes.find(s => s.payType === 'wxpay')" @click="uploadWxCode">
            <svg class="icon" aria-hidden="true" slot="icon">
              <use xlink:href="#icon-wechat"></use>
            </svg>
            <span class="iconTip">修改收款码</span>
          </p>
          <p v-else  style="height: 0.2rem;">&nbsp;</p>
          <div v-if="!qrocodes.find(s => s.payType === 'wxpay')" class="upload" @click="uploadWxCode">
            <span class="add">+</span>
            <br />
            点击添加收款码
            <br />
            微信
          </div>
          <img :class="qrocodes.find(s => s.payType === 'wxpay') ? '' : 'mask'" :src="qrocodes.find(s => s.payType === 'wxpay') ?
                            qrocodes.find(s => s.payType === 'wxpay').qrocde :
                            '../../../static/img/wxCodeBackUp.png'
                        ">
        </div>
        &nbsp;&nbsp;
        <div class="uploadAlipay">
        	 <p v-if="qrocodes.find(s => s.payType === 'alipay')" class="reload" @click="uploadAlipayCode">
            <svg class="icon" aria-hidden="true" slot="icon">
              <use xlink:href="#icon-alipay"></use>
            </svg>
            <span>修改收款码</span>
          </p>
          <p v-else  style="height: 0.2rem;">&nbsp;</p>
          <div v-if="!qrocodes.find(s => s.payType === 'alipay')" class="upload" @click="uploadAlipayCode">
            <span class="add">+</span>
            <br />
            点击添加收款码
            <br />
            支付宝
          </div>
          <img :class="qrocodes.find(s => s.payType === 'alipay') ? '' : 'mask'" :src="qrocodes.find(s => s.payType === 'alipay') ?
                            qrocodes.find(s => s.payType === 'alipay').qrocde :
                            '../../../static/img/alipayCodeBackUp.png'
                        ">
        </div>
      </div>
      <br />
      <!-- 提现按钮 -->
      <div class="saveContainer">
        <mt-button class="save" :disabled="isDisable" @click="profitTakeApply">提现</mt-button>
      </div>
      <p class="tip">因腾讯T+7周期，提现申请后7天内到账。</p>
      <!-- 重新上传组件 -->
      <mt-actionsheet :actions="actions" v-model="sheetVisible"></mt-actionsheet>
      <!-- 上传输入框 -->
      <input class="hidden" id="uploadWxCode" type="file" accept="image/*" action="" :value="time" method="post" @change="uploadWxCodeCallBack" />
      <input class="hidden" id="uploadAlipayCode" type="file" accept="image/*" action="" :value="time" method="post" @change="uploadAlipayCodeCallBack" />
    </div>
  </div>
</template>

<script>
import Upload from '../comm/Upload';
import { Toast } from 'mint-ui';

export default {
  props: ['property', 'withDrawAll', 'qrocodes', 'withDrawValue'],
  name: 'WithDrawCode',
  components: {
    Upload,
  },
  data() {
    return {
      time: null, //TODO time 不知道干嘛用的，上面加了，导致报错，先发一下个在这里
      isDisable: false,
      sheetVisible: false,
      actions: [
        {
          name: '更改微信收款码',
          method: this.uploadWxCode,
        },
        {
          name: '更改支付宝收款码',
          method: this.uploadAlipayCode,
        },
      ],
      value: 0,
    };
  },
  methods: {
    uploadWxCode: function() {
      document.getElementById('uploadWxCode').click();
      this.value = this.value + 1;
      console.log('uploadWxCode');
    },
    uploadAlipayCode: function() {
      document.getElementById('uploadAlipayCode').click();
      this.value = this.value + 1;
      console.log('uploadAlipayCode');
    },
    uploadWxCodeCallBack(file) {
      // 将微信收款二维码单独分开一个action
      this.$store.dispatch(
        'user/uploadWxQrcodeCode',
        file,
        this.qrocodes.length === 2
      );
    },
    uploadAlipayCodeCallBack(file) {
      this.$store.dispatch(
        'user/uploadAlipayQrcodeCode',
        file,
        this.qrocodes.length === 2
      );
    },
    profitTakeApply: function() {
      if (this.withDrawValue > this.property.usable / 100) {
        Toast('提现金额不得大于可提现金额');
        return;
      }
      if (this.withDrawValue < 50) {
        Toast('提现金额不得小于50元');
        return;
      }
      if (this.withDrawValue > 5000) {
        Toast('提现金额不得大于5000元');
        return;
      }
      //防止重复提交
      this.isDisable = true;
      setTimeout(() => {
        this.isDisable = false;
      }, 3000);
      this.$store.dispatch('user/profitTakeApply', this.withDrawValue);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.saveContainer {
  padding: 0 0.15rem;
}
.save {
  color: #fff;
  margin: 0 auto;
  width: 100%;
  background: #009688;
}
.codeContainer {
  padding: 0 0.15rem;
}
.codeContainer div {
  text-align: center;
  width: 50%;
  height: 50%;
}
.codeContainer div img {
  width: 80%;
}
.upload {
  position: absolute;
  width: 42% !important;
  height: unset !important;
  font-weight: 600;
  z-index: 99;
}

.uploadWx img {
  border: 1px solid #24aa39;
}
.uploadAlipay img {
  border: 1px solid #019fe8;
}
.mask {
  opacity: 0.2;
  background: #000;
}
.add {
  font-size: 0.5rem;
}
.reload {
  color: #7f7f7f;
}
.tip {
  text-align: center;
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  color: #7f7f7f;
}
.uploadAgain {
  text-align: center;
  color: #7f7f7f;
  font-size: 0.14rem;
  margin-bottom: 8px;
}
.reload svg {
  position: relative;
  top: 4px;
  width: 0.18rem;
}
</style>



// WEBPACK FOOTER //
// src/components/userWithDrawElement/WithDrawCode.vue